import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../contexts/AppContext";
import Loading from "../components/Loading";

import Layout from "../components/Layout";

const PrivateRoute = () => {
  const { loggedIn, loading } = useAuth();

  if (loading) {
    return <Loading fullScreen message="Verificando autenticação..." />;
  }

  if (!loggedIn) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default PrivateRoute;
